export default __webpack_public_path__ + "static/media/Karnataka8.0c7d832f.png";